var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"giftee-app-icon",attrs:{"src":_vm.gifteeAppIcon,"alt":"giftee-app-icon"}})}
var staticRenderFns = []

export { render, staticRenderFns }